import { Button } from '../components/ui/button'
import Modal from '../components/Modal'
import { JobRecord } from '@/types/job'
import { JobStatusTag } from './JobStatusTag'

const msg = {
  jobDetailsTitle: 'Job Details',
  jobIdLabel: 'Job ID',
  nameLabel: 'Name',
  statusLabel: 'Status',
  executorIdLabel: 'Executor ID',
  descriptionLabel: 'Description',
  createdByLabel: 'Created By',
  tenantIdLabel: 'Tenant ID',
  createdAtLabel: 'Created At',
  configLabel: 'Configuration',
  closeButton: 'Close',
}

type JobDetailsModalProps = {
  job: JobRecord | null
  isOpen: boolean
  onClose: () => void
}

const DetailField = ({
  label,
  value,
}: {
  label: string
  value: React.ReactNode
}) => (
  <div>
    <p className="text-sm font-medium text-gray-600 dark:text-gray-400">{label}</p>
    <div className="rounded-md p-2 bg-gray-50 dark:bg-dark-muted text-gray-800 dark:text-dark-text">{value}</div>
  </div>
)

const JobDetailsModal = ({ job, isOpen, onClose }: JobDetailsModalProps) => {
  if (!job) return null

  return (
    <Modal isOpen={isOpen} onClose={onClose} title={msg.jobDetailsTitle}>
      <div className="grid gap-4 py-4">
        <DetailField label={msg.jobIdLabel} value={job.id} />
        <DetailField label={msg.nameLabel} value={job.name} />
        <DetailField
          label={msg.statusLabel}
          value={<JobStatusTag status={job.status} />}
        />
        <DetailField label={msg.executorIdLabel} value={job.executor_id} />
        {job.description && (
          <DetailField label={msg.descriptionLabel} value={job.description} />
        )}
        <DetailField label={msg.createdByLabel} value={job.created_by} />
        <DetailField label={msg.tenantIdLabel} value={job.tenant_id} />
        <DetailField
          label={msg.createdAtLabel}
          value={new Date(job.created_at).toLocaleString()}
        />

        {/* Config (Key-Value) */}
        {job.config && Object.keys(job.config).length > 0 && (
          <div>
            <p className="text-sm font-medium text-gray-600 dark:text-gray-400">
              {msg.configLabel}
            </p>
            <div className="border rounded-md p-3 bg-gray-50 dark:bg-dark-muted">
              {Object.entries(job.config).map(([key, value]) => (
                <div
                  key={key}
                  className="flex justify-between border-b py-1 last:border-0"
                >
                  <span className="font-medium">{key}:</span>
                  <span>{JSON.stringify(value)}</span>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>

      <div className="flex justify-end gap-2">
        <Button variant="outline" onClick={onClose}>
          {msg.closeButton}
        </Button>
      </div>
    </Modal>
  )
}

export default JobDetailsModal
